import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

type PortfolioDomainRegistryEntry = {
	editRoute: (portfolioId: number) => string;
};

export const portfolioDomainRegistry: Partial<
	Record<ClientPortfolioDomainEnum, PortfolioDomainRegistryEntry>
> = {
	[ClientPortfolioDomainEnum.BuildingSavings]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditBuildingSavings.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.Cryptocurrencies]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditCryptocurrency.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.Leasing]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditLeasing.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.BusinessLoans]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditBusinessLoans.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.Commodities]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditCommodities.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.BankingProducts]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditBankProduct.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.PensionProducts]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditPension.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.Investments]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditInvestment.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.LifeInsurance]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditLifeInsurance.path(portfolioId),
	},
	[ClientPortfolioDomainEnum.Services]: {
		editRoute: (portfolioId) =>
			Routing.Portfolio.PortfolioEditServices.path(portfolioId),
	},
};
